<h2 mat-dialog-title translate>validate-user.steeluser</h2>
<mat-dialog-content>
	<div class="copo-simple-dialog-content dialog-box-info">
		<div>
			<b><span class="label-orange-color" translate>{{infoStatus}}</span></b>
		</div>
	</div>
</mat-dialog-content>
<button mat-raised-button class="button-container" color="primary" type="submit" (click)="closeDialog()">
	<span translate>dialog.close</span>
</button>